import CampMapModal from './modals/CampMapModal';

import $ from 'jquery';
import { mapUrl, mapData } from './maps/map-data';


$('.js-open-gmap-button').on('click', event => {
  event.preventDefault();
  event.stopPropagation();
  let campMapModal;

  if (typeof $(event.target).data('camp_map_modal') === 'undefined') {
    campMapModal = new CampMapModal(mapData, mapUrl);
    $(event.target).data('camp_map_modal', campMapModal);
  } else {
    campMapModal = $(event.target).data('camp_map_modal');
  }

  campMapModal.open();
});



// WEBPACK FOOTER //
// ./src/js/bundle_camp_lp.js